import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerMultiPromptTemplate,
  BackendMutationReleaseExpertMultiPromptTemplateArgs,
} from 'src/types/backend';

import { FRAGMENT_MULTI_PROMPT_TEMPLATE } from './schema';

const MUTATION = gql`
  mutation ReleaseExpertMultiPromptTemplate($id: ID!) {
    releaseExpertMultiPromptTemplate(id: $id) {
      ...CustomerMultiPromptTemplate
    }
  }
  ${FRAGMENT_MULTI_PROMPT_TEMPLATE}
`;

type Variables = BackendMutationReleaseExpertMultiPromptTemplateArgs;
type Result = BackendCustomerMultiPromptTemplate;

export const releaseExpertMultiPromptTemplate = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(response.data);
};
